/** MODALMOBILE: TODO */
import React, { useContext } from 'react'

import ForgotPasswordForm from '../hookforms/forms/ForgotPasswordForm'
import ModalFullscreen, { Props } from './ModalFullscreen'
import ModalLogin from './ModalLogin'
import P from '../typography/P'
import { ASpan as A } from '../typography/A'
import { ModalsContext } from './Modals'

const ModalForgotPassword: React.FC<Props> = (props) => {
  const modalsCtx = useContext(ModalsContext)
  return (
    <ModalFullscreen {...props}>
      <P>
        Enter your email address below, and we will e-mail instructions for
        setting a new one.
      </P>
      <ForgotPasswordForm />
      <A onClick={() => modalsCtx!.show(<ModalLogin />)}>Back to Log In</A>
    </ModalFullscreen>
  )
}

export default ModalForgotPassword
